import { api } from './backend'; 

export const list =(page, limit, filters)=> api.get('/front/ebooks',{ params: { page, limit, ...filters }});  

export const findBySlugName = (data) => api.get(`/front/ebooks/${data}`);
 
export const findAll =()=> api.get('/front/ebooks'); 